import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import PinInput from "@/components/ui/forms/formPINInputComponent/formPINInput.component";
import type { ContextoGrupoLogin } from "../loginUnificado.types";
import { CODIGO_GRUPO_FIELD_LABEL_CLASSNAME } from "../../loginForm.constants";
import type { FormularioEntrarJwtProps } from "../../FormularioEntrarJwt";
import clsx from "clsx";

// --------------------------------- TYPES ---------------------------------
type IdentificacaoGrupoLoginProps = FormularioEntrarJwtProps & {
	readonly grupo: ContextoGrupoLogin;
	readonly codigo: string;
	readonly carregando: boolean;
	readonly aoAlterar: (codigo: string) => void;
	readonly aoCompletar: (codigo: string) => void;
	readonly aoTrocar: () => void;
};

// ------------------------------- COMPONENT -------------------------------
export default function IdentificacaoGrupoLogin({
	grupo,
	codigo,
	carregando,
	aoAlterar,
	aoCompletar,
	aoTrocar,
	densidade = "normal",
}: Readonly<IdentificacaoGrupoLoginProps>) {
	// ----------------------------- DERIVED STATE ----------------------------
	const compacto = densidade === "compacta";

	// -------------------------------- RETURN --------------------------------
	if (grupo.origem === "codigo")
		return (
			<div className="space-y-2">
				<p className={CODIGO_GRUPO_FIELD_LABEL_CLASSNAME}>Código do grupo</p>
				<p className="text-xs text-[#5d6b82]">4 dígitos, informados pela sua empresa.</p>

				<PinInput
					size={compacto ? "compact" : "default"}
					length={4}
					value={codigo}
					onChange={aoAlterar}
					onComplete={aoCompletar}
					autoFocus
					autoComplete="off"
					disabled={carregando}
					aria-label="Código do grupo"
					className={clsx(
						"[&>.MuiBox-root]:items-start! [&_.MuiOutlinedInput-root]:rounded-[10px]!",
						compacto
							? "[&_.MuiTextField-root]:w-12! [&_.MuiOutlinedInput-root]:h-12!"
							: "[&_.MuiTextField-root]:w-12! sm:[&_.MuiTextField-root]:w-14!",
					)}
				/>
			</div>
		);

	const lembrado = grupo.origem === "lembrado";
	const texto = lembrado ? grupo.nome : `${globalThis.location.host}/g/${grupo.identificacao?.valor ?? ""}`;

	return (
		<div className="flex items-center gap-3 rounded-xl border border-[#d5dce6] bg-white px-2 py-2">
			<FuseSvgIcon size={22} className="shrink-0 text-[#047857]" aria-hidden="true">
				lucide:check
			</FuseSvgIcon>
			<div className="min-w-0 flex-1">
				<p className="text-[10px] font-semibold tracking-[0.08em] text-[#047857] uppercase">
					{lembrado ? "Grupo deste dispositivo" : "Empresa identificada pelo link"}
				</p>
				<p className="truncate text-sm font-semibold text-[#0b1f3f]" title={texto ?? undefined}>
					{texto}
				</p>
			</div>
			<button
				type="button"
				disabled={carregando}
				onClick={aoTrocar}
				className="shrink-0 cursor-pointer rounded-lg px-2 py-1.5 text-sm font-semibold text-[#504a99] focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
			>
				{lembrado ? "Trocar" : "Usar código"}
			</button>
		</div>
	);
}
